import { Badge, Box, FlexLayout, Text } from '@deity/falcon-ui';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { themeVariables } from 'styling/theme';
import { getParams } from 'utils';
import type { SubHeaderNavItemType } from './nav-items';
import { matchingPaths } from './nav-items';

const SubHeaderNavItem: FC<SubHeaderNavItemType> = ({ label, to, icon, count }) => {
  const { primary, secondaryDark } = themeVariables.colors;
  const { pathname } = useLocation();
  const [entityIsActive, setEntityIsActive] = useState(false);
  const [constructedTo, setConstructedTo] = useState<string>('#');

  useEffect(() => {
    const params: any = getParams(pathname, matchingPaths);
    if (params) {
      setConstructedTo(`/packages/${params.packageId}/${params.versionUuid}/${to}`);
      setEntityIsActive(params.entity === to);
    }
  }, [pathname]);

  return (
    <Box mr="lg">
      <Link style={{ textDecoration: 'none' }} to={constructedTo}>
        <FlexLayout alignItems="center">
          <FlexLayout alignItems="center" style={{ color: entityIsActive ? primary : secondaryDark }}>
            {icon}
          </FlexLayout>

          <Text
            fontWeight="bold"
            ml="xs"
            color={entityIsActive ? 'primary' : 'secondaryDark'}
            style={{ textTransform: 'uppercase', lineHeight: 0 }}
          >
            {label}
          </Text>

          {count != null && (
            <Badge
              variant="round"
              bg={entityIsActive ? 'primaryLight' : 'secondaryLight'}
              color={entityIsActive ? 'primary' : 'secondary'}
              style={{ lineHeight: 0 }}
              ml="xs"
            >
              {count}
            </Badge>
          )}
        </FlexLayout>
      </Link>
    </Box>
  );
};

export default SubHeaderNavItem;
